/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {
  Button,
  Grid,
  Typography,
  TextField,
  Switch,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import EditIcon from '@material-ui/icons/Edit';
import MomentUtils from '@date-io/moment';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? '#deebff' : 'white',
    color: 'black',
    width: '100%',
    fontSize: '14px',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: '56px',
    marginTop: '16px',
    fontSize: '16px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  menu: (provided) => ({ ...provided, zIndex: 98 }),
};

const SemesterUpdate = ({
  data, closeModal, semestersArr, referentsList, updateSemester, isCompany,
}) => {
  const [form, setForm] = useState({
    semester: '',
    referents: data.referents,
    needFormer: data.needFormer,
    presentialGroups: parseInt(data.presentialGroups, 10),
    presentialHours: parseFloat(data.presentialHours / 60),
    elearningHours: parseFloat(data.elearningHours / 60),
    beginDate: data.beginDate,
    endDate: data.endDate,
    catchUpDate: data.catchUpDate ? data.catchUpDate : null,
  });

  useEffect(() => {
    semestersArr.forEach((semester) => {
      if (data.semester && semester.value === data.semester) {
        setForm({ ...form, semester });
      }
    });
  }, [semestersArr]);
  return (
    <Grid container spacing={2} style={{ width: '100%', padding: '20px' }}>
      <Grid item md={6}>
        <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
          {isCompany ? 'Parcours' : 'Semestre'}
        </Typography>
        <Select
          value={form.semester}
          options={semestersArr}
          // getOptionLabel={(option) => `Semestre ${option.value}`}
          placeholder={isCompany ? 'Parcours' : 'Semestre'}
          isDisabled
          styles={customStyles}
        />
      </Grid>
      <Grid item md={6}>
        <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
          référent
        </Typography>
        <Select
          value={form.referents}
          styles={customStyles}
          isMulti
          name="referents"
          options={referentsList}
          getOptionLabel={(option) => `${option.name} ${option.firstname}`}
          placeholder="Réferent(s).."
          onChange={(e) => {
            setForm({ ...form, referents: e });
          }}
        />
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Date de début
          </Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
              required
              autoOk
              inputMode="none"
              fullWidth
            // error={errors.beginDate}
              format="DD/MM/YYYY"
              onChange={(e) => {
                const tmpDate = new Date(e._d);
                tmpDate.setHours(10);
                setForm({ ...form, beginDate: tmpDate });
              }}
              value={form.beginDate || ''}
              helperText={`Date de début du ${isCompany ? 'parcours' : 'semestre'}`}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Date de fin
          </Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
              required
              autoOk
              inputMode="none"
              fullWidth
            // error={errors.endDate}
              format="DD/MM/YYYY"
              onChange={(e) => {
                const tmpDate = new Date(e._d);
                tmpDate.setHours(10);
                setForm({ ...form, endDate: tmpDate });
              }}
              value={form.endDate || ''}
              helperText={`Date de fin du ${isCompany ? 'parcours' : 'semestre'}`}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Date de fin de session 2 (*optionnel)
          </Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
              required
              autoOk
              inputMode="none"
              fullWidth
            // error={errors.endDate}
              format="DD/MM/YYYY"
              onChange={(e) => {
                const tmpDate = new Date(e._d);
                tmpDate.setHours(10);
                setForm({ ...form, catchUpDate: tmpDate });
              }}
              value={form.catchUpDate || ''}
              helperText="Date de rattrapage"
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            {'Heures d\'e-learning'}
          </Typography>
          <TextField
            onChange={(e) => setForm({ ...form, elearningHours: e.target.value })}
            id="outlined-uncontrolled"
            variant="outlined"
            value={form.elearningHours || ''}
        //   error={errors.elearningHours}
            fullWidth
          />
        </Grid>
        <Grid
          item
          md={5}
          // onClick={() => setForm({ ...form, neddFormer: !form.needFormer })}
          style={{
            display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '15px',
          }}
        >
          <Typography>
            Avez-vous besoin d&apos;un formateur EW ?
          </Typography>
          <br />
          <br />
          <Switch
            checked={form.needFormer}
            onClick={() => setForm({ ...form, needFormer: !form.needFormer })}
            name="checkRecurent"
            color="primary"
          />

          {form.needFormer
            ? <Typography>oui</Typography>
            : <Typography>non</Typography>}
        </Grid>
      </Grid>
      {form.needFormer
        && (
        <Grid container spacing={2}>
          <Grid item md={6}>
            <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
              heures de présentiel
            </Typography>
            <TextField
              onChange={(e) => setForm({ ...form, presentialHours: e.target.value })}
              id="outlined-uncontrolled"
              variant="outlined"
            //   error={errors.presentialHours}
              value={form.presentialHours || ''}
              fullWidth
            />
          </Grid>
          <Grid item md={6}>
            <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
              Groupe(s) en présentiel
            </Typography>
            <TextField
              onChange={(e) => setForm({ ...form, presentialGroups: e.target.value })}
              id="outlined-uncontrolled"
              variant="outlined"
              value={form.presentialGroups || ''}
              fullWidth
            />
          </Grid>
        </Grid>
        )}
      <Grid md={6}>
        <Button
          onClick={() => {
            updateSemester(form, 'updateSemester');
            closeModal();
          }}
          style={{ marginTop: '3.3em', padding: '1em 0 1em 0' }}
          variant="contained"
          color="primary"
          startIcon={<EditIcon>Update</EditIcon>}
          fullWidth
        >
          Mettre à jour
        </Button>
      </Grid>
    </Grid>
  );
};

SemesterUpdate.propTypes = {
  data: PropTypes.object.isRequired,
  closeModal: PropTypes.string.isRequired,
  semestersArr: PropTypes.array.isRequired,
  isCompany: PropTypes.bool.isRequired,
  referentsList: PropTypes.array.isRequired,
  updateSemester: PropTypes.func.isRequired,
};

export default SemesterUpdate;
